import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation
} from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import { Toaster } from "alert";

import "./App.css";
// import Loader from "./components/Loader";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Prijslijst from "./pages/Prijslijst";
import Behandelingen from "./pages/Behandelingen";
import BehandelingDetail from "./pages/behandelingen/BehandelingDetail";
import Afspraak from "./pages/Afspraak";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Oneliner from "./components/Oneliner";
import Bento from "./components/Bento";
import Marquee from "./components/Marquee";
import Instagram from "./components/Instagram";

import Email from "./pages/Email";
import Invoice from "./pages/Invoice";

import "./styles/styles.scss";

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);
    return () => clearTimeout(timer);
  }, [location]);

  return null;
};

const ToasterComponent = () => {
  const location = useLocation();
  const shouldShowToaster = location.pathname !== "/afspraak";
  if (!shouldShowToaster) return;
  return <Toaster position="bottom-right" theme="dark" duration={1000} />;
};

const App = () => {
  return (
    <Provider store={store}>
      <Router>
        <div className="App">
          <ToasterComponent />
          <ScrollToTop />
          {/* <Loader /> */}
          <Header />
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Hero />
                  <Services />
                  <Marquee />
                  <Bento />
                  <Oneliner />
                  <Instagram />
                </>
              }
            />
            <Route path="/prijslijst" element={<Prijslijst />} />
            <Route path="/behandelingen" element={<Behandelingen />} />
            <Route
              path="/behandelingen/:behandelingId"
              element={<BehandelingDetail />}
            />
            <Route path="/afspraak" element={<Afspraak />} />
            <Route path="/afspraak/:stepNo" element={<Afspraak />} />
            <Route path="/email" element={<Email />} />
            <Route path="/invoice" element={<Invoice />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </Provider>
  );
};

export default App;
